import { SVGProps } from "react";

const GisIcon = (props: SVGProps<SVGSVGElement>) => {
	return (
		<svg
			width="32"
			height="32"
			viewBox="0 0 32 32"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M28.0007 16.0001C28.0007 14.5239 27.721 13.1159 27.2334 11.8098C27.1044 16.1086 22.7351 19.4369 20.1698 21.6394H26.5908C27.4883 19.9576 28.0007 18.0391 28.0007 16.0001ZM23.3589 6.53464C21.3258 4.95183 18.7768 4 16.0006 4C9.37291 4 4 9.37291 4 16.0001C4 22.6273 9.37291 28 16.0006 28C19.0355 28 21.7989 26.8645 23.9123 25.0063H15.2242L15.1977 22.4549C20.4326 17.9041 23.6416 14.8265 23.6416 11.8537C23.6416 10.749 23.2208 9.35481 21.327 9.35481C19.8274 9.35481 18.3808 10.2234 18.6437 13.8531H15.5926C14.8295 9.64475 17.1182 6.30366 21.4844 6.30366C22.1613 6.30366 22.7875 6.38446 23.3589 6.53464Z"
				fill="#A3C400"
			/>
		</svg>
	);
};

export default GisIcon;
